var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mAboutAgency"},[(!_vm.item.withinfo.withwe)?_c('NoData'):_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.item.withinfo.withwe)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }